import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { Table } from 'reactstrap';
import { IncentivesEntities } from 'client/data/models/incentives';
import { INCENTIVE_HEAD_TITLES } from 'site-modules/shared/constants/incentives';

export function IncentiveFinancingInfo({ incentive: { aprs = [], startDate, endDate } = {}, titleType }) {
  const titles = get(INCENTIVE_HEAD_TITLES, titleType, []);

  return (
    <Table className="mb-0 mt-1 body incentive-financing-info">
      <thead>
        <tr>
          <th className="fw-medium p-0_5 p-md-0_75" scope="col">
            {titles[0]}
          </th>
          <th className="fw-medium p-0_5 p-md-0_75" scope="col">
            {titles[1]}
          </th>
          <th className="fw-medium p-0_5 p-md-0_75" scope="col">
            {titles[2]}
          </th>
          <th className="fw-medium p-0_5 p-md-0_75" scope="col">
            {titles[3]}
          </th>
        </tr>
      </thead>
      <tbody>
        {aprs
          .sort((a, b) => a.termMonths - b.termMonths)
          .map(({ apr, termMonths }, index) => {
            const key = `ape-${apr}-${index}`;

            return (
              <tr key={key}>
                <td className="p-0_5 p-md-0_75">{apr}%</td>
                <td className="p-0_5 p-md-0_75">{termMonths}</td>
                <td className="p-0_5 p-md-0_75 h5 fw-normal align-middle">{startDate}</td>
                <td className="p-0_5 p-md-0_75 h5 fw-normal align-middle">{endDate}</td>
              </tr>
            );
          })}
      </tbody>
    </Table>
  );
}

IncentiveFinancingInfo.propTypes = {
  incentive: IncentivesEntities.IncentivesGraphql,
  titleType: PropTypes.string.isRequired,
};
